export default "__VITE_ASSET__c6ef247c__"